import { Request } from '@group-devs/yfp7-global-modules'
import {useEffect} from 'react'
import Head from 'next/head'
import { Footer } from '@group-devs/yfp7-global-modules/components/Block'
import ReactGA from 'react-ga';

const request = new Request(process.env.apiDomain)

const VitalityForLife = (props) => {
    const site = props.global.site
    const { data: hub } = request.website.swrSite(site.accountId, "HUB")
    const { data: nav } = request.website.swrNavigation(hub ? hub.url : hub)
    const { data: tracker } = request.insights.swrTracking(site.id)

    useEffect(()=>{
        if (tracker)
        {
            if (tracker.ga_id)
            {
                ReactGA.initialize(tracker.ga_id);
                ReactGA.pageview(window.location.pathname + window.location.search);
            }
            if (tracker.matomo_id && tracker.matomoServer)
            {
                var _paq = window._paq = window._paq || [];
                _paq.push(['trackPageView']);
                _paq.push(['enableLinkTracking']);
                (function() {
                    var u= (tracker.matomoServer.includes("http") ? "" : "//") + tracker.matomoServer.replace(/\/$/, "");
                    _paq.push(['setTrackerUrl', u+'/matomo.php']);
                    _paq.push(['setSiteId', tracker.matomo_id]);
                    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                    g.type='text/javascript'; g.async=true; g.src=u+'/matomo.js'; s.parentNode.insertBefore(g,s);
                })();
            }
        }
      }, [tracker])

    return (
        <>
        <Head>
            <meta property="og:url" content="dynamic url"/>
            <meta property="og:site_name" content="Vitality for Life Monthly Newsletter"/>
            <meta property="og:title" content="Vitality for Life Monthly Newsletter"/>
            <meta property="og:description" content="Sign up for my FREE monthly newsletter and stay updated on Shaklee's newest products, specials & promos. And get my best tips on how to live a healthier more vibrant life."/>
            <meta property="og:image" content="../images/vfl/img-vitality-share01.jpg"/>
            <link rel="shortcut icon" type="image/x-icon" href="../images/vfl/favicon-vitality.png"/>
        </Head>
            {props.children}
            { nav ? <Footer host={props.global.host} site={site} navigation={nav.footer_navigation} /> : null }
            <style jsx global>{`
                @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@500&display=swap" rel="stylesheet');
                body {
                    font-family: "Raleway", sans-serif;
                }

            `}</style>
        </>
    )
}

export default VitalityForLife